window.addEventListener('DOMContentLoaded', function () {
  const btnMsbToggle = document.querySelector('.btn-msb-toggle');
  btnMsbToggle.addEventListener('click', function (event) {
    event.preventDefault();
    document.body.classList.toggle('msb-x');
  });
});
